import { Popover, Typography } from 'antd';
import React, { ReactElement } from 'react';
import './emails.less';

export default function PersonLink(props: {
    email: string;
    name: string;
}): ReactElement {
    const { email, name } = props;

    const content: ReactElement = (
        <>
            <Typography.Text
                className='name'
                strong={true}
            >
                {name || email}
            </Typography.Text>
            <a href={`mailto:${email}`}>{email}</a>
        </>
    );

    return (
        <Popover
            content={content}
            overlayClassName='loan-emails-person-popover'
            placement='bottom'
        >
            <a
                className='loan-emails-person-link'
                href={`mailto:${email}`}
            >
                {name || email}
            </a>
        </Popover>
    );
}
